import React, { FC } from 'react';
import './unread-indicator.scss';

const UnreadIndicator: FC = () => {
  return <div className='unread-indicator' />;
};

export default UnreadIndicator;
